/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';
import { failureCode } from 'shared/constants.json';

const debugEnv = import.meta.env.DEV;
const DEBUG_ENABLED = false;
export const debug = (...data) => {
  if (DEBUG_ENABLED) console.debug(...data);
};

const logError = (err, ctx = undefined) => {
  if (debugEnv) {
    console.error(err, ctx);
    return;
  }
  datadogRum.addError(err, ctx);
};

const interceptedFailures = [failureCode.stepUpRequired, failureCode.maintenanceMode];

export const failureOf = (err) => err?.data ?? err?.response?.data;

export const failureCodeOf = (err) => failureOf(err)?.code;

export const logCatch = (fn = () => {}, expected = []) => (err) => {
  const code = failureCodeOf(err);
  if (!interceptedFailures.includes(code) && !expected.includes(code)) {
    logError(err);
  }
  return fn(err);
};
